import React, { useState, useEffect, Fragment, useMemo } from "react";
import { makeStyles, Checkbox, Button } from "@material-ui/core";

import { Dialog, DialogTitle, DialogActions } from "@material-ui/core";
import LoadingFloating from "../../components/LoadingFloating";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import Grid from "../../components/Grid";
import divisions from "../../divisions.json";

export default function Address({ areaData, onChangeAreaData = () => {} }) {
  const useStyles = makeStyles({
    DocumentContainerLeft: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
  });
  const selectStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  }));
  const selectClasses = selectStyles();
  const classes = useStyles();

  const [areaOpen, setAreaOpen] = useState(false);
  const areaClose = () => {
    setAreaOpen(false);
  };
  // console.log("Render title component");
  const [AreaIndex, setAreaIndex] = React.useState(null);
  const areaClick = (index) => {
    if (AreaIndex === index) {
      setAreaIndex(null);
    } else {
      setAreaIndex(index);
    }
  };
  const [areaState, setAreaState] = useState([]);

  const [divisionArray, setDivisionArray] = useState([]);
  useEffect(() => {
    const divisionKey = Object.keys(divisions);
    const newDivisionArray = [
      {
        label: "全選",
        value: "全選",
      },
    ];
    divisionKey.map((item) => {
      const newSubdivisionsArray = [];
      Object.keys(divisions[item].subdivisions).map((item2) => {
        newSubdivisionsArray.push({
          value: item2,
          label: divisions[item].subdivisions[item2].zhTW,
        });
      });
      newDivisionArray.push({
        value: item,
        label: divisions[item].zhTW,
        subdivisions: newSubdivisionsArray,
      });
    });
    setDivisionArray(newDivisionArray);
  }, []);
  return (
    <>
      <Grid
        item
        xs={4}
        sm={2}
        container
        classes={{ root: classes.DocumentContainerLeft }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ fontSize: 13 }}
          onClick={() => setAreaOpen(true)}
          fullWidth
        >
          縣市區域
        </Button>
        <Dialog
          open={areaOpen}
          fullWidth
          maxWidth={false}
          classes={{ paper: classes.dialogPaper }}
        >
          <LoadingFloating loading={false} />
          <DialogTitle align="center">縣市區域</DialogTitle>
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={classes.root}
          >
            {divisionArray.map((item, index) => (
              <Fragment key={index}>
                <ListItem
                  role={undefined}
                  dense
                  button
                  onClick={() => areaClick(index + 1)}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={Boolean(
                        areaState.find((item2) => item2.value === item.value)
                      )}
                      tabIndex={-1}
                      disableRipple
                      onClick={(event) => {
                        event.stopPropagation();
                        const has = areaState.find(
                          (sourceItem) => sourceItem.value === item.value
                        );
                        if (has) {
                          if (item.value === "全選") {
                            setAreaState([]);
                          } else {
                            areaState.map((item2, index2) => {
                              if (item2.value === item.value) {
                                areaState.splice(index2, 1);
                              }
                            });
                            setAreaState((e) => [...e]);
                          }
                        } else {
                          if (item.value === "全選") {
                            const newAreaState = [];
                            for (let i = 0; i < divisionArray.length; i++) {
                              newAreaState.push(divisionArray[i]);
                            }
                            setAreaState(newAreaState);
                          } else {
                            setAreaState((e) => [
                              ...e,
                              {
                                ...item,
                                subdivisions: [...item.subdivisions],
                              },
                            ]);
                          }
                        }
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={item.label} />
                  {item.label !== "全選" ? (
                    AreaIndex === index + 1 ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )
                  ) : null}
                </ListItem>
                {AreaIndex === index + 1 &&
                  item.subdivisions &&
                  item.subdivisions.map((item2, index2) => {
                    const hasSubdivision = areaState.find((item3) => {
                      if (item3.value === item.value) {
                        return Boolean(
                          item3.subdivisions.find(
                            (item4) => item4.value === item2.value
                          )
                        );
                      } else {
                        return false;
                      }
                    });
                    return (
                      <Collapse
                        key={index2}
                        in={AreaIndex}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>
                          <ListItem
                            className={selectClasses.nested}
                            role={undefined}
                            dense
                          >
                            <ListItemIcon>
                              <Checkbox
                                edge="start"
                                checked={Boolean(hasSubdivision)}
                                tabIndex={-1}
                                disableRipple
                                onClick={() => {
                                  const hasSubdivision = areaState.find(
                                    (item3) => {
                                      if (item3.value === item.value) {
                                        return Boolean(
                                          item3.subdivisions.find(
                                            (item4) =>
                                              item4.value === item2.value
                                          )
                                        );
                                      } else {
                                        return false;
                                      }
                                    }
                                  );
                                  if (hasSubdivision) {
                                    areaState.map((item3) => {
                                      if (item3.value === item.value) {
                                        item3.subdivisions.map(
                                          (item4, index2) => {
                                            if (item4.value === item2.value) {
                                              item3.subdivisions.splice(
                                                index2,
                                                1
                                              );
                                            }
                                          }
                                        );
                                      }
                                    });
                                  } else {
                                    const hasAddressArray = areaState.find(
                                      (item3) => item3.value === item.value
                                    );
                                    if (hasAddressArray) {
                                      areaState.map((item3) => {
                                        if (item3.value === item.value) {
                                          item3.subdivisions.push(item2);
                                        }
                                      });
                                    } else {
                                      areaState.push({
                                        ...item,
                                        subdivisions: [item2],
                                      });
                                    }
                                  }
                                  setAreaState((e) => [...e]);
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText primary={item2.label} />
                          </ListItem>
                        </List>
                      </Collapse>
                    );
                  })}
              </Fragment>
            ))}
          </List>
          <DialogActions>
            <Grid container spacing={1} justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    onChangeAreaData(areaState);
                    areaClose();
                  }}
                >
                  確定
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setAreaState([]);
                    areaClose();
                  }}
                >
                  取消
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}
